<p>MY CLOUD GATEWAY PORTAL</p>
<p>
  APP RELEASE ID <span class="version-number">{{ versionNumber }}</span>
</p>
